import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DefaultModalProps,
  withLocationStateModal,
  useOpenModal,
} from 'utils/modals';

import { Box, Typography, Link, Button } from '@mui/material';

import { EXTERNAL_LINKS } from '@libs/helpers/consts';
import { DefaultModal } from '@libs/ui/components/modals';

import { PerksModals } from './types';

interface DisclaimerProps {}

// Modal component
interface DisclaimerModalProps extends DefaultModalProps<void> {}

const DisclaimerModalComponent = ({ close, isOpen }: DisclaimerModalProps) => {
  const { t } = useTranslation('perks');

  return (
    <DefaultModal
      open={isOpen}
      handleClose={close}
      title={t('disclaimer.title')}
      actions={
        <Button
          fullWidth
          variant="contained"
          color="info"
          onClick={close}
          size="large"
        >
          {t('disclaimer.gotIt')}
        </Button>
      }
    >
      <Box sx={{ textAlign: 'left' }}>
        <Typography variant="body1" paragraph mt={4}>
          {t('disclaimer.body1')}
        </Typography>

        <Typography variant="body1" paragraph>
          {t('disclaimer.body2')}
          <Typography
            component="a"
            href={EXTERNAL_LINKS.contactEmail}
            color="info.main"
            sx={{ textDecoration: 'none' }}
          >
            hello@opentalent.co
          </Typography>
          {t('disclaimer.body3')}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {t('disclaimer.footer')}
        </Typography>
      </Box>
    </DefaultModal>
  );
};

const DisclaimerModal = withLocationStateModal<void>({
  id: PerksModals.DISCLAIMER,
})(DisclaimerModalComponent);

// Hook
const useOpenDisclaimerModal = () => useOpenModal<void>(PerksModals.DISCLAIMER);

// Main component
export const Disclaimer: React.FC<DisclaimerProps> = () => {
  const { t } = useTranslation('perks');
  const openDisclaimerModal = useOpenDisclaimerModal();

  return (
    <>
      <Box>
        <Typography variant="body2" color="text.secondary">
          {t('disclaimer.questionsPrefix')}
          <Link
            component="button"
            variant="body2"
            onClick={() => openDisclaimerModal()}
            color="info.main"
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          >
            {t('disclaimer.readDisclaimer')}
          </Link>
          .
        </Typography>
      </Box>
      <DisclaimerModal />
    </>
  );
};
